// bulkCreateContact.js
import { URL_BULK_CREATE_CONTACTS } from "constants/urls";

/**
 * Extracts the first complete JSON object from a string, even if the server
 * accidentally concatenates multiple JSON objects like: {...}{...}
 */
function parseFirstJsonObject(rawText) {
  const text = rawText.trim();
  const start = text.indexOf("{");
  if (start === -1) {
    throw new Error("Server returned no JSON object.");
  }

  // Try to find the end of the FIRST top-level JSON object by brace matching.
  let depth = 0;
  let end = -1;
  for (let i = start; i < text.length; i++) {
    const ch = text[i];
    if (ch === "{") depth++;
    else if (ch === "}") {
      depth--;
      if (depth === 0) {
        end = i + 1;
        break;
      }
    }
  }
  if (end === -1) {
    // Fall back to naive parse (will throw), helps surface the exact parse error
    return JSON.parse(text);
  }

  const firstObjText = text.slice(start, end);
  return JSON.parse(firstObjText);
}


const bulkCreateContacts = async (contacts, listId = 0, sync = false) => {
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    body: JSON.stringify({
      payload: contacts, // send the array directly
      listId, // 0 = don't add to any mail list; >0 = add all contacts to that list
      sync, // true = make the list match the CSV exactly (remove members not in the CSV)
    }),
  };

  const res = await fetch(URL_BULK_CREATE_CONTACTS, options);
  const responseText = await res.text(); // text first

  try {
    // Parse only the FIRST JSON object to survive accidental concatenation.
    const parsed = parseFirstJsonObject(responseText);

    // Normalize: your server writes "Payload". The UI expects "Data".
    // Make a shallow copy with Data mapped if needed.
    const normalized = parsed && parsed.Payload !== undefined
      ? { ...parsed, Data: parsed.Payload }
      : parsed;

    return normalized;
  } catch (error) {
    console.error("JSON parse error:", error);
    console.error(
      "Response was:",
      responseText.substring(0, 500) + "..."
    );
    throw new Error(
      `Server returned non-JSON response: ${responseText.substring(0, 100)}...`
    );
  }
};

/**
 * Sync a mail list to match the uploaded CSV exactly: contacts in the CSV are added/created and
 * any current list member not in the CSV is removed. Thin wrapper over bulkCreateContacts.
 */
export const syncContactsToList = (contacts, listId) =>
  bulkCreateContacts(contacts, listId, true);

export default bulkCreateContacts;
